import { Fragment } from 'react';
import { ChevronRight } from 'lucide-react';
import { cn } from '@/lib/utils';

// Shared header for every Settings detail pane (translates the design's HMPaneHead): optional
// breadcrumb, title, description, and a right-aligned action slot. Fixed at the top of the pane;
// the pane body scrolls beneath it.
export function PaneHeader({ crumb, title, description, action }) {
  return (
    <div className="flex shrink-0 items-end gap-4 border-b border-border px-6 py-4">
      <div className="min-w-0">
        {Array.isArray(crumb) && crumb.length > 0 ? (
          <div className="mb-1.5 flex items-center gap-1.5 text-[12.5px] font-semibold text-muted-foreground">
            {crumb.map((c, i) => {
              const isLast = i === crumb.length - 1;
              return (
                <Fragment key={i}>
                  {c.onClick && !isLast ? (
                    <button
                      type="button"
                      onClick={c.onClick}
                      className="rounded text-muted-foreground transition hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
                    >
                      {c.label}
                    </button>
                  ) : (
                    <span className={isLast ? 'text-foreground' : 'text-muted-foreground'}>{c.label}</span>
                  )}
                  {!isLast ? <ChevronRight className="h-3.5 w-3.5 text-muted-foreground" aria-hidden /> : null}
                </Fragment>
              );
            })}
          </div>
        ) : null}
        <h2 className={cn('text-[22px] font-extrabold tracking-tight text-foreground')}>{title}</h2>
        {description ? (
          <p className="mt-0.5 max-w-2xl text-[13px] text-muted-foreground">{description}</p>
        ) : null}
      </div>
      {action ? <div className="ml-auto shrink-0">{action}</div> : null}
    </div>
  );
}
